import { restClient } from 'libs/restClient';
import { notifyMessages } from 'helpers/NotifyHelper';
import { downloadFile } from 'helpers/Uploads';
import {
  prepareDocStatusArgs,
  prepareTestResultArgs
} from 'helpers/ArgsHelper';
import { formatValue, getHtmlCollectionSelectedValues } from 'libs/form';
import * as actions from 'actions/types';

export function fetchRequestTests(requestId) {
  const url = `/requesttests?include=reports,requesttestconductinglabs,lab&where=requestid=${requestId}`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_REQUEST_TESTS,
    payload
  };
}

export function sendTestResult(testModule) {
  const args = prepareTestResultArgs(testModule);
  const payload = restClient
    .put(`/requesttests/${testModule.id}`, JSON.stringify(args))
    .then(response => {
      if (response.status === 200) {
        return Promise.resolve(true);
      }
      return Promise.reject(notifyMessages.cantSendTestResult);
    })
    .catch(err => {
      return Promise.reject(notifyMessages.cantSendTestResult);
    });

  return {
    type: actions.SEND_TEST_RESULT,
    payload
  };
}

export function testReportDownload(document, request) {
  const { testId, requesttestid, slot } = document;
  const test = testId || requesttestid; // TODO: get rid of this

  // file name pattern: CBRSA00000_TestModule_Slot.extension
  // e.g. CBRSA00345_WINNFTS0122_3.pdf
  const fileName = `${request.tn}_WINNFTS0122_${slot}.${document.document.extension}`;

  const url = `/requesttests/${test}/reports/${slot}?download=1`;
  const payload = restClient
    .get(url, { responseType: 'blob' })
    .then(response => {
      downloadFile(response.data, fileName);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DOWNLOAD_TEST_REPORT,
    payload
  };
}

export function changeTestField(testId, event) {
  const { id, name, value } = event.target;
  const field = id || name;

  return {
    type: actions.CHANGE_TEST_FIELD,
    payload: {
      field,
      testId,
      value: formatValue(field, value)
    }
  };
}

export function changeTestDate(testId, fieldName, value) {
  return {
    type: actions.CHANGE_TEST_FIELD,
    payload: {
      field: fieldName,
      testId,
      value
    }
  };
}

export function changeTestMultiField(testId, event) {
  const { id, options } = event.target;
  const value = getHtmlCollectionSelectedValues(options);

  return {
    type: actions.CHANGE_TEST_FIELD,
    payload: {
      field: id,
      testId,
      value
    }
  };
}

export function fetchTestReports(testId) {
  const url = `/requesttests/${testId}/reports`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_TEST_REPORTS,
    payload
  };
}

export function clearTests() {
  return { type: actions.CLEAR_TESTS };
}

export function updateTestReportStatus(testId, slot, status) {
  const url = `/requesttests/${testId}/reports/${slot}`;
  const body = prepareDocStatusArgs(status);
  const payload = restClient
    .put(url, body)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_REPORT_STATUS,
    payload
  };
}

export function deleteTestReport(testId, slot) {
  const url = `/requesttests/${testId}/reports/${slot}`;
  const payload = restClient
    .delete(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DELETE_TEST_REPORT,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/tests.js